import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type ConfirmState = {
  open: boolean
  closing: boolean
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  danger: boolean
  resolve: ((value: boolean) => void) | null
}

type ConfirmActions = {
  show: (opts: {
    title?: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
    danger?: boolean
  }) => Promise<boolean>
  respond: (value: boolean) => void
  finishClose: () => void
}

export const useConfirmStore = create<ConfirmState & ConfirmActions>()(
  devtools(
    (set, get) => ({
      open: false,
      closing: false,
      title: '확인',
      message: '',
      confirmLabel: '확인',
      cancelLabel: '취소',
      danger: false,
      resolve: null,

      show: (opts) => {
        // 이전 pending 호출이 있으면 false로 정리 후 새 호출 시작 (메모리 누수 방지)
        const prev = get().resolve
        prev?.(false)

        return new Promise<boolean>((resolve) => {
          set({
            open: true,
            closing: false,
            title: opts.title ?? '확인',
            message: opts.message,
            confirmLabel: opts.confirmLabel ?? '확인',
            cancelLabel: opts.cancelLabel ?? '취소',
            danger: opts.danger ?? false,
            resolve,
          })
        })
      },

      respond: (value) => {
        const { open, resolve } = get()
        if (!open) return
        set({ open: false, closing: true, resolve: null })
        resolve?.(value)
      },
      finishClose: () => {
        if (!get().open) set({ closing: false })
      },
    }),
    { name: 'confirm-store' }
  )
)

export const confirm = (
  message: string,
  opts?: {
    title?: string
    confirmLabel?: string
    cancelLabel?: string
    danger?: boolean
  }
) => useConfirmStore.getState().show({ message, ...opts })
